import * as util from './../Scripts/General.js';

//const developer = true;

let google = null;
let setZoomAfterIdle = 8;
const defaultZoom = 8;
let map = null;
let selectedHardwareID = 0;
let timerWait4Map = 0;

let markerBounds;
let allReadyToAccPoints = [];

export function GetAllReadyToAccPoints() {
    util.Fetch('GetAllReadyToAccPoints')
        .then(json => {
            allReadyToAccPoints = json.Data;
            timerWait4Map = setTimeout(Check4Map,100);
        })
        .catch(error => {
            alert('بروز اشکال در بازیابی اطلاعات!')
        });
}
export function InitMap(g) {
    google = g;
    SetupMap();
    GetAllReadyToAccPoints();
    return map;
}
function SetupMap() {
    map = new google.maps.Map(document.getElementById('map'), {
        zoom: defaultZoom,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        fullscreenControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP
        },
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
        },
        controlSize: 24,
        clickableIcons: false
    });
    map.addListener('click', function (event) {
        selectedHardwareID = 0;
        CloseAllInfoWindows();
    });
    map.addListener('idle', function () {
        //if (typeof developer !== 'undefined')
            //ClearGoogleMapDeveloperWindow();
        if (setZoomAfterIdle >= 0) {
            if (map.getZoom() > setZoomAfterIdle)
                map.setZoom(setZoomAfterIdle);
            setZoomAfterIdle = -1;
        }
    });
}
function CloseAllInfoWindows() {
    for (let hIndex = 0; hIndex < allReadyToAccPoints.length; hIndex++)
        allReadyToAccPoints[hIndex].INW.close();
}
function CreatePositionsOnMap() {
    markerBounds = new google.maps.LatLngBounds();
    for (let hIndex = 0; hIndex < allReadyToAccPoints.length; hIndex++) {
        let hardware = allReadyToAccPoints[hIndex];
        hardware.MRK = new google.maps.Marker({
            map: map,
            position: { lat: hardware.Latitude, lng: hardware.Longitude },
            title: hardware.CompanyName,
            icon: GetPinImage(),
            index: hIndex,
            hid: hardware.ID
        });

        markerBounds.extend(hardware.MRK.getPosition());

        let readyDate = new Date(hardware.ReadyDate);
        readyDate = `${1 + readyDate.getMonth()}/${readyDate.getDate()}/${readyDate.getFullYear()} ${(readyDate.getHours() + ``).padStart(2, '0')}:${(readyDate.getMinutes() + ``).padStart(2, '0')}`;
        let iwHTML = `<div class="positionInfoWindow">`;
        iwHTML += `<div class="main">`;
        iwHTML += `<div class="readyDate">${readyDate}</div>`;
        iwHTML += `<div class="gmt">(GMT)</div>`;
        iwHTML += `<br />`;
        iwHTML += `<div class="machineType">${hardware.MachineType}</div>`;
        iwHTML += `<br />`;
        iwHTML += `<div class="companyNameTitle">Company:</div>`;
        iwHTML += `<div class="companyName">${hardware.CompanyName}</div>`;
        iwHTML += `<br />`;
        if (hardware.TelNo !== '' && IsMobileOrTablet())
            iwHTML += `<div class="telNo">Tel: <a href="tel:${hardware.TelNo.replace(/\(/g, '').replace(/\)/g, '').replace(/-/g, '')}">${hardware.TelNo}</a></div>`;
        else if (hardware.TelNo !== '')
            iwHTML += `<div class="telNo">Tel: ${hardware.TelNo}</div>`;
        if (hardware.FaxNo !== '') iwHTML += `<div class="faxNo">Fax: ${hardware.FaxNo}</div>`;
        if (hardware.Email !== '') iwHTML += `<div class="email">E-mail: <a href="mailto:${hardware.Email}">${hardware.Email}</a></div>`;
        let wa = hardware.Whatsapp.replace(/\(/g, '').replace(/\)/g, '').replace(/-/g, '');
        if (hardware.Whatsapp !== '') {
            if (IsMobileOrTablet())
                iwHTML += `<div class="whatsapp">WhatsApp: <a href="https://wa.me/${wa}">${hardware.Whatsapp}</a></div>`;
            else
                iwHTML += `<div class="whatsapp">WhatsApp: <a target="_blank" href="https://wa.me/${wa}">${hardware.Whatsapp}</a></div>`;
        }
        iwHTML += `</div>`;
        iwHTML += `<div class="line"></div>`;
        iwHTML += `</div>`;

        let infW = new google.maps.InfoWindow({
            content: iwHTML,
            index: hIndex,
            maxWidth: 180,
            pixelOffset: new google.maps.Size(105, 11)
        });
        ///let $iwContent = $(infW.content);
        ///$iwContent.height($iwContent.height());
        hardware.INW = infW;
        hardware.MRK.addListener('click', function () {
            ShowHardware(this.hid);
        });
    }

    if (allReadyToAccPoints.length > 0)
        map.fitBounds(markerBounds);
    setZoomAfterIdle = 8;
    setTimeout(() => setZoomAfterIdle = -1, 1000); // if idle doesn't happen
}
function GetPinImage() {
    const iconURL = "../Images/Report/Marker.png";
    const iconSizeX = 28;
    const iconSizeY = 33;
    const anchorX = 14;
    const anchorY = 33;
    return {
        url: iconURL,
        scaledSize: new google.maps.Size(iconSizeX, iconSizeY),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(anchorX, anchorY)
    };
}
function IsMobileOrTablet () {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function ShowHardware(hardwareID) {
    CloseAllInfoWindows();
    if (hardwareID === selectedHardwareID)
        selectedHardwareID = 0;
    else {
        selectedHardwareID = hardwareID;
        ShowVehicleInfo();
    }
}
function ShowVehicleInfo() {
    let hardware = GetHardware(selectedHardwareID);
    if (hardware.ID > 0)
        hardware.INW.open(map, hardware.MRK);
}
function GetHardware(hid) {
    for (let hIndex = 0; hIndex < allReadyToAccPoints.length; hIndex++)
        if (allReadyToAccPoints[hIndex].ID == hid)
            return allReadyToAccPoints[hIndex];
    return { ID: 0 };
}
/*
function ClearGoogleMapDeveloperWindow() {
    let checkDeveloperWind = setInterval(function () {
        let developerWindow = $("div[style*='background-color: white; font-weight: 500; font-family: Roboto, sans-serif; padding: 15px 25px; box-sizing: border-box; top: 5px; border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 5px;']");
        if (typeof $(developerWindow).css('display') !== 'undefined') {
            clearInterval(checkDeveloperWind);
            $(developerWindow).hide();
        }
    }, 250);
    setInterval(function () {
        clearInterval(checkDeveloperWind);
    }, 10000);
}
*/
function Check4Map() {
    if (google === null)
        return;
    clearTimeout(timerWait4Map);
    CreatePositionsOnMap();
}
